var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.688,
    height: 35.349,
    viewBox: "0 0 166.688 35.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_17918",
    "data-name": "Raggruppa 17918",
    transform: "translate(-347.344 -92.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_6644",
    "data-name": "Raggruppa 6644",
    transform: "translate(347.344 92.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M249.32,268.057h4.559c3.491,0,6.6.765,6.6,5.115s-3.113,5.115-6.6,5.115H249.32Zm-7.355,28.32h7.355V284.131h6.617c8.516,0,11.816-5.406,11.816-10.955s-3.3-10.955-11.816-10.955H241.965Z",
    transform: "translate(-241.965 -261.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M307.017,296.017c0-4.041,1.435-8.081,6.187-8.081,4.8,0,6.238,4.041,6.238,8.081,0,3.992-1.435,8.032-6.238,8.032-4.751,0-6.187-4.041-6.187-8.032m-7.028,0c0,7.984,5.2,13.241,13.215,13.241,8.069,0,13.265-5.258,13.265-13.241,0-8.032-5.2-13.29-13.265-13.29-8.018,0-13.215,5.258-13.215,13.29",
    transform: "translate(-275.502 -273.909)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_18",
    "data-name": "Rettangolo 18",
    width: 6.794,
    height: 34.156,
    transform: "translate(53.41 0.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M396.514,262.22H389.72v5.6h6.794Zm-6.794,34.156h6.794v-24.73H389.72Z",
    transform: "translate(-326.616 -261.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M509.215,307.935h6.695V296.285c0-4.353,1.82-7.884,6.8-7.884a9.464,9.464,0,0,0,1.051-.033v-5.744s-.111-.252-1.191-.235c-3.3.051-4.837.573-6.218,3.512h-.433v-2.7h-6.7Z",
    transform: "translate(-395.525 -272.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M413.408,296.135H420.2V275.948h4.688V271.4h-4.851v-1.594c0-2.056,1.125-2.83,4.732-2.83V261.8h-4.16c-4.419,0-7.472,1.937-7.472,7.685V271.4h-3.291v4.522l3.558.026Z",
    transform: "translate(-337.705 -261.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M449.147,296.017c0-4.041,1.435-8.081,6.188-8.081,4.8,0,6.238,4.041,6.238,8.081,0,3.992-1.437,8.032-6.238,8.032-4.752,0-6.188-4.041-6.188-8.032m-7.028,0c0,7.984,5.2,13.241,13.216,13.241,8.069,0,13.265-5.258,13.265-13.241,0-8.032-5.2-13.29-13.265-13.29-8.018,0-13.216,5.258-13.216,13.29",
    transform: "translate(-356.333 -273.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M546.987,308.111h6.575V293.768c0-4.828,3.148-5.688,4.447-5.688,4.166,0,3.981,3.3,3.981,6.167v13.862h6.573V294.345c0-3.107.695-6.262,4.4-6.262,3.749,0,4.027,2.725,4.027,6.023v14.01h6.573V291.572c0-6.405-3.656-8.843-8.749-8.843a8.641,8.641,0,0,0-7.221,4.114c-1.3-2.963-3.979-4.114-6.989-4.114-3.1,0-5.2.819-6.913,3.353H553.6V283.4h-6.6Z",
    transform: "translate(-416.873 -273.91)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9dfd16921a722a68617c85ec756024f1.svg";
export { ForwardRef as ReactComponent };